// extracted by mini-css-extract-plugin
export default {"container":"team-logos-module__container___rdAo2","separator":"team-logos-module__separator___Ic2U9","vs":"team-logos-module__vs___XTlZb common-module__verticalAlignChild___BZS5n"};